module.exports = __webpack_public_path__ + "static/judah.f5bf96d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/judah.jpg
// module id = 1085
// module chunks = 35783957827783